import {
  Box,
  Button,
  Drawer,
  Grid,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import Title from "./Title";
import { useEffect, useState } from "react";
import { CustomTabPanel } from "./CustomTabPanel";
import { Card } from "./Card";
import { useServiceDrawer } from "../features/returns/useServiceDrawer";
import toast from "react-hot-toast";
import {
  assignReturns,
  bookReturnsMethod,
  fetchRateRequest,
} from "../features/returns/returnApi";
import { StyledButton } from "./StyledButton";
import Amazon from "../../assests/Amazon-logo-meaning.jpg";
import Xpress from "../../assests/xpressLogo.avif";
import BlueDart from "../../assests/bluedartLogo.png";
import delhiveryLogo from "../../assests//delhiveryLogo.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FormVal } from "../../components/features/returns/ReturnsDetail";
import { useMessageDialog } from "../../context/MessageDialogContext";

interface dataType {
  id: number;
  error: boolean;
  quote_id: number;
  delivery_by: string;
  mode: string;
  cod_charge: number;
  amount: number;
  service: string;
}

const RateReturnAssignDrawer = () => {
  const [activeTab, setActiveTab] = useState(0);

  const [data, setData] = useState<dataType[]>([]);

  const [returnData, setReturnData] = useState<FormVal>();

  const [isLoading, setIsLoading] = useState(false);

  const { id, onOpenSchedule, isOpen, onClose } = useServiceDrawer();

  const handleTabChange = (_event: React.SyntheticEvent, newValue: any) => {
    setActiveTab(newValue);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const { showMessage } = useMessageDialog();

  useEffect(() => {
    if (isOpen) {
      fetchRateRequest(id)
        .then((data) => {
          if (data.data?.status === "success") {
            let finalData = data?.data?.data;
            finalData.map((el: any) => (el.id = el.quote_id));
            setData(finalData);
          }
        })
        .catch((error) => console.log(error));
    } else {
      setData([]);
    }
  }, [isOpen, id]);

  const assignReturnsHandler = (quoteId: number) => {
    assignReturns({
      id,
      quote_id: quoteId,
    })
      .then((data) => {
        bookReturnsMethod([`${id}`])
          .then((data) => {
            showMessage("Success","Returns Booked successfullys!");
            searchParams.set("returnId", `${id}`);
            setSearchParams(searchParams);
            onOpenSchedule(id);
            onClose();
          })
          .catch((err) => {
            showMessage("Error","Try again later!");
            // toast.error(err.response?.data?.message);
          });
      })
      .catch((err) => console.log(err));
  };

  const WhichImage = (service: string) => {
    if (service.includes("xpressbees")) return Xpress;
    if (service.includes("amazon")) return Amazon;
    if (service.includes("delhivery")) return delhiveryLogo;
    if (service.includes("bluedart")) return BlueDart;

    return "";
  };

  const navigate = useNavigate();

  const navigateToOrder = () => {
    onClose();
    return navigate(`returns/details/${id}`);
  };

  return (
    <>
      <Drawer open={isOpen && !isLoading} onClose={() => onClose("")} anchor="right">
        <div
          className="rate-order-assign"
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "35%",
              height: "100%",
              background: "#217aee",
              color: "#fff",
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                flexDirection: "column",
                rowGap: "30px",
              }}
            >
              <p
                style={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Order Details Order
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Pickup From <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  {returnData?.shipper_address_address}
                </span>
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Deliiver To <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  {returnData?.receiver_address_address}
                </span>
              </p>
              <p
                style={{
                  fontSize: "12px",
                }}
              >
                Value <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  Rs. {returnData?.invoice_value}
                </span>
              </p>
              {/* <p
                style={{
                  fontSize: "12px",
                }}
              >
                Payment Mode <br />
                <span
                  style={{
                    fontSize: "20px",
                  }}
                >
                  COD
                </span>
              </p> */}

              <StyledButton
                onClick={navigateToOrder}
                variant="contained"
                sx={{
                  marginTop: "100px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  ":hover": {
                    backgroundColor: "#ffffffd1",
                  },
                }}
              >
                View All Details
              </StyledButton>
            </div>

          </div>
          {/* <Box>
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Stack
                  width={"100%"}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Title title="Select Courier Partner" />
                  <Button onClick={() => onClose("")}>X</Button>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                  }}
                >
                  <Tabs
                    value={activeTab}
                    onChange={(
                      e: React.SyntheticEvent<Element, Event>,
                      number: any
                    ) => handleTabChange(e, number)}
                  >
                    <Tab label={"Air"} />
                    <Tab label={"Road"} />
                  </Tabs>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <CustomTabPanel value={activeTab} index={0}>
                  <Card
                    style={{
                      width: "100%",
                    }}
                  >
                    <Typography fontSize={"14px"} margin={"14px 4px"}>
                      {data?.length || 0} Couriers Found
                    </Typography>

                    <TableContainer
                      sx={{
                        width: "100%",
                      }}
                    >
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Courier Partner</TableCell>
                            <TableCell>Estimated Delivery</TableCell>
                            <TableCell>Charges</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data &&
                            data?.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell>{row?.service}</TableCell>
                                <TableCell>{row?.delivery_by}</TableCell>
                                <TableCell>{row?.amount}</TableCell>
                                <TableCell>
                                  <StyledButton
                                    variant="contained"
                                    sx={{
                                      textTransform: "none",
                                    }}
                                    onClick={() =>
                                      assignReturnsHandler(row.quote_id)
                                    }
                                  >
                                    Ship Now
                                  </StyledButton>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </CustomTabPanel>
              </Grid>
            </Grid>
          </Box> */}

          <div
            style={{
              backgroundColor: "#f0f0f0",
              padding: "20px",
              color: "#000",
            }}
          >
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Stack
                  width={"100%"}
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Title title="Select Courier Partner" />

                  <Button onClick={() => onClose("")}>X</Button>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Grid
                  container
                  gap={"40px"}
                  style={{
                    height: "calc(100vh - 200px)",
                    overflowY: "scroll",
                    paddingBottom: "40px",
                  }}
                >
                  {data &&
                    data?.map((row, index) => (
                      <Grid item md={3.5} key={index}>
                        <Card>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              gap: "20px",
                              marginBottom: "40px",
                            }}
                          >
                            <div
                              style={{
                                background: "#fff",
                                height: "60px",
                                width: "60px",
                                borderRadius: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {WhichImage(row?.service) !== "" && (
                                <img
                                  style={{
                                    width: "80%",
                                    objectFit: "contain",
                                    objectPosition: "center",
                                    mixBlendMode: "multiply",
                                  }}
                                  src={WhichImage(row?.service)}
                                />
                              )}
                            </div>
                            <div>
                              <p>{row?.service}</p>
                              <p>Rating 4.7</p>
                            </div>
                          </div>
                          <div
                            style={{
                              background: "#f0f0f0",
                              padding: "20px",
                              borderRadius: "10px",
                            }}
                          >
                            <p>Estimated Delivery: {row?.delivery_by}</p>
                            <p>Charges: Rs. {row?.amount}</p>

                            <StyledButton
                              fullWidth
                              variant="contained"
                              sx={{
                                textTransform: "none",
                                marginTop: "100px",
                                backgroundColor: "#fff !important",
                                color: "#000",
                                borderRadius: "10px",
                                ":hover": {
                                  backgroundColor: "#ffffffd1 !important",
                                },
                              }}
                              onClick={() => assignReturnsHandler(row.quote_id)}
                            >
                              Ship Now
                            </StyledButton>
                          </div>
                        </Card>
                      </Grid>
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </div>
      </Drawer>
    </>
  );
};
export default RateReturnAssignDrawer;
